import React from "react";
import styled from "styled-components";
import LoadingSpinner from "@common/LoadingSpinner/LoadingSpinner";
import { FontSize } from "@themes/Fonts";

const ChatLoadingRow = styled.div`
    display: flex;
`;

const ChatLoadingLabel = styled.div`
    color: ${(props) => props.theme.textColorSecondary};
    font-size: ${FontSize.small};
    margin-left: 5px;
`;

interface ChatLoadingIndicatorProps {
    readonly label: string;
}
export default function ChatLoadingIndicator(props: ChatLoadingIndicatorProps) {
    return (
        <ChatLoadingRow>
            <LoadingSpinner size={15} />
            <ChatLoadingLabel>{props.label}</ChatLoadingLabel>
        </ChatLoadingRow>
    );
}
